import React, { useState, useContext } from "react";
import Button from "../../components/common/Button";
import api from "../../utils/api";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate, useLocation, Link } from "react-router-dom";

export default function LoginPage() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");

  const { loginSuccess } = useContext(AuthContext);
  const nav = useNavigate();
  const location = useLocation();

  // Redirect after login if coming from Chat
  const redirectTo =
    new URLSearchParams(location.search).get("redirect") || null;

  function change(e) {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    setError("");
  }

  async function submit(e) {
    e.preventDefault();
    setError("");

    try {
      const res = await api.post("/auth/login", {
        email: form.email,
        password: form.password,
      });

      loginSuccess(res.data);

      // If redirect exists -> go there
      if (redirectTo) {
        nav(redirectTo);
        return;
      }

      // Otherwise fallback by role
      const role = res.data.user.role;
      // if (role === "OWNER") nav("/owner");
      if (role === "OWNER") nav("/add-listing");
      else if (role === "SEEKER") nav("/seeker");
      else nav("/");
    } catch (err) {
      const msg = err?.response?.data?.message;

      if (msg === "Please verify your email before logging in.") {
        setError(
          "Your email is not verified. Please check your inbox or resend the verification email.",
        );
      } else {
        setError(msg || "Login failed");
      }
    }
  }

  function goToSignup() {
    // Preserve redirect if user was trying to chat
    if (redirectTo) {
      nav(`/register?redirect=${encodeURIComponent(redirectTo)}`);
    } else {
      nav("/register");
    }
  }

  return (
    <div className="min-h-screen flex justify-center items-center">
      <div className="bg-white w-full max-w-md p-10 rounded-3xl shadow">
        <h1 className="text-3xl font-bold text-center">Welcome Back</h1>
        <p className="text-gray-500 text-center">Sign in to continue</p>

        {/* Error Message */}
        {error && (
          <div className="bg-red-100 text-red-600 p-3 mt-4 rounded-xl text-sm text-center">
            {error}
            {error.includes("not verified") && (
              <div className="mt-2">
                <Link
                  to="/resend-verification"
                  className="text-[#FF4A1F] font-semibold underline"
                >
                  Resend Verification Email
                </Link>
              </div>
            )}
          </div>
        )}

        <form onSubmit={submit} className="space-y-4 mt-6">
          <input
            name="email"
            value={form.email}
            onChange={change}
            className="border p-3 rounded-xl w-full"
            placeholder="Email address"
            type="email"
            required
          />

          <input
            name="password"
            value={form.password}
            onChange={change}
            className="border p-3 rounded-xl w-full"
            type="password"
            placeholder="Password"
            required
          />

          <div className="flex justify-between text-sm">
            <label>
              <input type="checkbox" className="mr-2" /> Remember me
            </label>

            {/* Working forgot password link */}
            <Link
              to="/forgot-password"
              className="text-[#FF4A1F] hover:underline"
            >
              Forgot password?
            </Link>
          </div>

          <Button
            variant="primary"
            className="w-full py-3 text-lg"
            type="submit"
          >
            Sign In
          </Button>
        </form>

        {/* Sign Up Section */}
        <div className="mt-6 text-center">
          <span className="text-gray-600">Don't have an account?</span>
          <br />
          <button
            onClick={goToSignup}
            className="mt-2 text-[#FF4A1F] font-semibold hover:underline"
          >
            Create an account
          </button>
        </div>
      </div>
    </div>
  );
}
